// extracted by mini-css-extract-plugin
module.exports = {"block":"SidebarWrapper_block__82H_D"};